import React from 'react'
import Slider from '../Slider/Slider'

export default function HireLaravelDev() {
  return (
    <>
            <div class="inner-page" id="nodejs-design-bg" data-aos="fade-up" data-aos-duration="1500">
            <div class="container">
                <div class="row">
                    <div class="col-lg-5">
                        <div class="inner_content" data-aos="fade-up" data-aos-duration="2000">
                            <h1>Hire Laravel Developer</h1>
                            <div aria-label="breadcrumb">
                                <ol class="breadcrumb">
                                    <li class="breadcrumb-item"><a href="index.html"><i
                                                class="ri-home-4-line"></i>Home</a></li>
                                    <li class="breadcrumb-item active" aria-current="page">Hire Laravel Developer</li>
                                </ol>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <section class="section" data-aos="fade-up" data-aos-duration="1500">
            <div class="container">
                <div class="heading row_gaping">
                    <h2 class="section-title-2 text-center">Engage Laravel Experts at the Best rates</h2>
                </div>
                <div class="center-row row row-below g-2 row-cols-lg-6 row-cols-sm-3 row-cols-2">
                    <div class="col-md text-center">
                        <div class="hire_content">
                            <img src="assets/image/hire-angular-icon-1.png" alt=""/>
                            <h5>One Week Free Trial</h5>
                        </div>
                    </div>
                    <div class="col-md">
                        <div class="hire_content">
                            <img src="assets/image/hire-angular-icon-2.png" alt=""/>
                            <h5>Minimum 3+ Years of Experience</h5>
                        </div>
                      
                    </div>
                    <div class="col-md">
                        <div class="hire_content">
                            <img src="assets/image/hire-angular-icon-3.png" alt=""/>
                            <h5>Non-Disclosure Agreement</h5>
                      </div>
                    </div>
                    <div class="col-md">
                        <div class="hire_content">
                            <img src="assets/image/hire-angular-icon-4.png" alt=""/>
                          
                            <h5>Flexible Hiring Models</h5>
                       </div>
                    </div>
                    <div class="col-md">
                        <div class="hire_content">
                        <img src="assets/image/hire-angular-icon-5.png" alt=""/>
                           
                        <h5>Competitive Rate</h5>
                        </div>
                    </div>
                    <div class="col-md">
                        <div class="hire_content">
                        <img src="assets/image/hire-angular-icon-6.png" alt=""/>
                        <h5>Source Code Delivery</h5>
                        </div>
                    </div>
                </div>
                <div class="btn_sec text-center row-below">
                    <a href="" class="btn1 btn_gap">Meet The Team</a>
                   <a href="" class="btn3">Recent Projects</a>
                    
                </div>
            </div>
        </section>

        <section class="section hire_content_anguler" data-aos="fade-up" data-aos-duration="1500">
            <div class="small-hire">
                
               <div class="row">
                <div class="col-lg-6 ml-auto">
                    <div class="small_hire_content">
                        <h3>WHAT CAN WE DO FOR YOU?</h3>
                        <p>We would be happy to discuss the project with you in person</p>
                        <h3 class="h3">Call us on <a href="telto:8420197208">+91 8420197208</a> </h3>
                        <div class="btn_sec">
                            <a href="" class="btn2">DROP IN A MESSAGE</a>
                        </div>
                    </div>
                </div>
               </div>
            </div>
        </section>

        <section class="section" data-aos="fade-up" data-aos-duration="1500">
            <div class="container">
               <div class="heading">
                <h2 class="section-title">Hire Offshore Laravel Developers to  Meet <br/> Custom Requirements</h2>
                <p class="section-subtitle pt-3">Elevate your web development projects with our offshore Laravel developers available for hire. Benefit from the efficiency and elegance of Laravel, a powerful PHP framework, for building robust and scalable web applications. Our developers bring expertise in crafting customized solutions tailored to your specific needs. Explore flexible engagement models designed to accommodate various project complexities and durations.</p>
               </div>

                <div class="row mb-5">
                    <div class="col-md-6 py-2">
                        <div class="bg-white req-card ">
                            <img src="assets/image/hire-angular-icon-7.png" alt=""/>
                            <h6 class="details-heading">Custom Web App Development</h6>
                            <p>Experience bespoke solutions with our Laravel experts. Our custom web app development combines Laravel's power and precision for a unique and scalable digital experience. Elevate your business with our proficiency. Contact us at  to discuss your project's individual needs and witness the seamless integration of cutting-edge technology into your web applications.</p>
                        </div>
                    </div>

                    <div class="col-md-6 py-2">
                        <div class="bg-white req-card ">
                            <img src="assets/image/hire-angular-icon-8.png" alt=""/>
                            <h6 class="details-heading">API Integration</h6>
                            <p class="">Empower your web applications with our Laravel expertise in API integration. Our developers ensure a seamless connection between your Laravel-based system and external APIs, enhancing functionality and data exchange. Whether integrating payment gateways, third-party services, or social media APIs, we provide efficient and secure solutions.</p>
                        </div>
                    </div>

                    <div class="col-md-6 py-2">
                        <div class="bg-white req-card  ">
                            <img src="assets/image/hire-angular-icon-9.png" alt=""/>
                            <h6 class="details-heading">Ajax Integration</h6>
                            <p class="">Transform your Laravel web applications into dynamic, real-time experiences with our Ajax integration services. Our experts seamlessly incorporate asynchronous requests, ensuring instant data updates and enhanced user interaction.</p>
                        </div>
                    </div>

                    <div class="col-md-6 py-2">
                        <div class="bg-white req-card  ">
                            <img src="assets/image/hire-angular-icon-10.png" alt=""/>
                            <h6 class="details-heading">Migration</h6>
                            <p class="">Upgrade your web application with our expert Laravel migration services. Whether you're transitioning from older Laravel versions or other frameworks, our team ensures a smooth and efficient migration process. We specialize in preserving data integrity, optimizing performance, and implementing the latest features of Laravel.</p>
                        </div>
                    </div>
                    <div class="col-md-6 py-2">
                        <div class="bg-white  req-card ">
                            <img src="assets/image/hire-angular-icon-11.png" alt=""/>
                            <h6 class="details-heading">Support & Maintenance</h6>
                            <p class="py-2">Ensure the continuous optimal performance of your Laravel web application with our dedicated support and maintenance services. Our expert team is committed to resolving issues promptly, applying updates, and proactively monitoring for potential issues.</p>
                        </div>
                    </div>
                    <div class="col-md-6 py-2">
                        <div class="bg-white req-card ">
                            <img src="assets/image/hire-angular-icon-12.png" alt=""/>
                            <h6 class="details-heading">Ecommerce Development</h6>
                            <p class="py-2">Transform your online business into a seamless and efficient platform with our Laravel Ecommerce development services. Our expert Laravel developers specialize in creating robust and scalable Ecommerce solutions tailored to your unique business needs.</p>
                        </div>
                    </div>
                </div>
            </div>
        </section>

        <section class="section bg_color" data-aos="fade-up" data-aos-duration="1500">
            <div class="container">
              <div class="heading  text-center">
                <h2>Why Choose Us</h2>
              </div>
                <div class="row g-3 ">
                    <div class="col-md-6 col-lg-3">
                        <div class="choose-us  text-center">
                            <div class="choose-us-img">
                                <img src="assets/image/hire-angular-icon-13.png" alt=""/>
                            </div>
                            <h5 class="my-3">Industry Experts</h5>
                            <p>Our in-house team is enriched with trusted and experienced developers - no freelancer.
                            </p>
                        </div>
                    </div>
                    <div class="col-md-6 col-lg-3">
                        <div class="choose-us  text-center">
                            <div class="choose-us-img">
                                <img src="assets/image/hire-angular-icon-14.png" alt=""/>
                            </div>
                            <h5 class="my-3">Widely recommended</h5>
                            <p>We got hundreds of real 5-star ratings and reviews on Google, GoodFirms, and Clutch
                                combined. </p>
                        </div>
                    </div>
                    <div class="col-md-6 col-lg-3">
                        <div class="choose-us  text-center">
                            <div class="choose-us-img">
                                <img src="assets/image/hire-angular-icon-15.png" alt=""/>
                            </div>
                            <h5 class="my-3">Customer Service
                            </h5>
                            <p>Our zero complaint work approach helps us to ensure a seamless customer experience.


                            </p>
                        </div>
                    </div>
                    <div class="col-md-6 col-lg-3">
                        <div class="choose-us  text-center">
                            <div class="choose-us-img">
                                <img src="assets/image/hire-angular-icon-16.png" alt=""/>
                            </div>
                            <h5 class="my-3">Ideal Workplace
                            </h5>
                            <p>We cultivate a productive work environment with a trendy setup to enhance the outcomes.


                            </p>
                        </div>
                    </div>
                    <div class="row-below btn_sec text-center">
                        <a href="" class="btn2 btn_gap">Get Started</a>
                        <a href="" class="btn2"> Our Clients</a>
                    
                    </div>
                </div>
            </div>
        </section>

        <section class="showcasing_sec" data-aos="fade-up" data-aos-duration="1500">
            <div class="container">
                <div class="row">
                    <div class="col-lg-12 text-center">
                        <div class="heading" data-aos="fade-down" data-aos-duration="2500">
                            <h2>Showcasing our Expertise</h2>
                            <p>
                                Transform your online business into a seamless and efficient platform with our Laravel Ecommerce development services. Our expert Laravel developers specialize in creating robust and scalable Ecommerce solutions tailored to your unique business needs.
                            </p>
                        </div>
                    </div>
                    <div class="col-lg-12">
                        <div class="owl-carousel owl-theme showcasing_slider">
                            <div class="item">
                                <div class="showcasing_content" data-aos="fade-up" data-aos-duration="2500">
                                    <div class="row g-4">
                                        <div class="col-lg-7">
                                            <div class="heading">
                                                <h4>Web design company in the world</h4>
                                                <p>
                                                    As a leading web design company in the world, Adret software stands at the forefront of Laravel development. Our expert team combines artistic flair with technical precision to create visually stunning and functionally superior websites..
                                                </p>
                                                <p>
                                                    Specializing in Laravel, we bring innovation and efficiency to every project, ensuring a seamless user experience. Whether it's crafting responsive interfaces, dynamic content, or scalable Ecommerce platforms, we pride ourselves on delivering world-class web design solutions.
                                                </p>
                                                <div class="btn_sec">
                                                    <a href="" class="btn2">View Portfolio</a>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="col-lg-5">
                                            <img src="assets/image/home-new-swap-signal.png" class="img-fluid" alt=""/>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="item">
                                <div class="showcasing_content" data-aos="fade-up" data-aos-duration="2500">
                                    <div class="row g-4">
                                        <div class="col-lg-7">
                                            <div class="heading">
                                                <h4>Web Development Technologies</h4>
                                                <p>
                                                    We have a team of web developers in the World, who have expertise in
                                                    various web development technologies. They specialise in developing
                                                    websites using CMS platforms like WordPress, Joomla, Drupal, and
                                                    Magento. They also develop custom web applications using
                                                    technologies like PHP, Node.js, React, Angular, and Vue.js.
                                                </p>
                                                <p>
                                                    Our developers are well-versed in HTML, CSS, JavaScript, and other
                                                    front-end technologies, ensuring that every website they develop is
                                                    responsive, visually appealing, and easy to navigate.
                                                </p>
                                                <div class="btn_sec">
                                                    <a href="" class="btn2">View Portfolio</a>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="col-lg-5">
                                            <img src="assets/image/home-new-swap-signal.png" class="img-fluid" alt=""/>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="item">
                                <div class="showcasing_content" data-aos="fade-up" data-aos-duration="2500">
                                    <div class="row g-4">
                                        <div class="col-lg-7">
                                            <div class="heading">
                                                <h4> Mobile App Development</h4>
                                                <p>
                                                    Adret Software is a leading mobile app development company in the
                                                    World that provides a wide range of services to clients worldwide.
                                                    With years of experience and expertise in the field, Adret Software
                                                    has earned a reputation for delivering high-quality mobile
                                                    applications that cater to the specific needs of its clients.
                                                </p>
                                                <p>
                                                    In this article on mobile app development services in the World, we
                                                    will explore the services and features that Adret Software offers to
                                                    its clients.
                                                </p>
                                                <div class="btn_sec">
                                                    <a href="" class="btn2">View Portfolio</a>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="col-lg-5">
                                            <img src="assets/image/home-new-swap-signal.png" class="img-fluid" alt=""/>
                                        </div>
                                    </div>
                                </div>
                            </div>

                        </div>
                    </div>
                </div>
            </div>
        </section>

        <Slider/>

        <section class="section careers_sec1" id="faq_sec" data-aos="fade-up" data-aos-duration="1500">
            <div class="container">
                <div class="row">
                    <div class="col-lg-12">
                        <div class="heading">
                            <h2 class="section-title ">Laravel Development – Frequently Asked Question</h2>
                            <p class="section-subtitle">Clarify your doubts about Laravel before availing Laravel
                                development services.</p>
                            <div class="col-md-12">
                                <div class="accordion">

                                    <div class="accordion__item">
                                        <h2 class="accordion__title">How do I get started with your Laravel
                                            services?</h2>
                                        <div class="accordion__body">
                                            <p> Getting started with our Laravel services is seamless. Begin by reaching out to us at to discuss your project requirements, goals, and vision. Our dedicated team will promptly respond, providing insights, understanding your needs, and offering tailored solutions.</p>
                                        </div>
                                    </div>
                                    <div class="accordion__item">
                                        <h2 class="accordion__title ">How do your website development services benefit
                                            my business?</h2>
                                        <div class="accordion__body">
                                            <p>Our Laravel services provide a myriad of benefits to elevate your business. Experience accelerated development timelines, thanks to Laravel's elegant syntax and extensive feature set, ensuring a quicker time-to-market. Benefit from robust security measures, protecting your sensitive data and ensuring a secure online environment for your users.</p>
                                        </div>
                                    </div>
                                    <div class="accordion__item">
                                        <h2 class="accordion__title ">Will it be possible to hire website developers on
                                            demand for custom requirements?</h2>
                                        <div class="accordion__body">
                                            <p>You can hire our Laravel developers on demand to meet your unique and custom requirements. Whether it's a specific feature, a complete web application, or ongoing maintenance, our flexible engagement models adapt to the complexity and duration of your project.</p>
                                        </div>
                                    </div>


                                </div>

                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    </>
  )
}
